import { omit, pick, mergeDeepRight, pipe } from 'ramda';
import * as ruleCreators from 'js/utils/Validation/validationRules';

export const handleAmountRequired = (method) => {
    const { amountRequired, validationConfig } = method;
    const { amount } = validationConfig;

    return {
        ...method,
        validationConfig: {
            ...validationConfig,
            amount: {
                ...amount,
                required: amountRequired != null
                    ? amountRequired
                        ? amount.required || true // may be an object
                        : false
                    : amount.required
            }
        }
    };
};

export const mergeAccountFieldsValidation = (method) => {
    const { accountFields, validationConfig } = method;

    if (!accountFields) {
        return method;
    }

    let nextValidConfig = {};

    accountFields.forEach((item) => {
        const { isRequired, name } = item;
        const cfg = { required: Boolean(isRequired) };
        const reChar = '/';
        let { validation = '' } = item;
        let opts = '';
        let lastIdx;

        if (validation) {
            if (validation[0] === reChar) {
                lastIdx = validation.lastIndexOf(reChar);
                opts = validation.substring(lastIdx + 1);
                validation = validation.substring(1, lastIdx);
            }

            cfg.regexp = {
                re: new RegExp(`^$|(${validation})`, opts)
            };
        }

        nextValidConfig = {
            ...nextValidConfig,
            [name]: mergeDeepRight(cfg, validationConfig[name] || {})
        };
    });

    return {
        ...method,
        validationConfig: {
            ...validationConfig,
            ...nextValidConfig
        }
    };
};

export const handleAmountRange = (method) => {
    const { limits, validationConfig } = method;
    const { amount } = validationConfig;
    const minMax = ['min', 'max'];
    let { range: amountRange = {} } = amount;

    if (amount && amountRange) {
        if (limits || amountRange.min || amountRange.max) {
            if (limits) {
                amountRange = {
                    ...amountRange,
                    ...pick(minMax, limits)
                };
            }
        } else {
            // Do not use range validation without actual limits
            return {
                ...validationConfig,
                amount: omit(['range'], amount)
            };
        }
    }

    return {
        ...method,
        validationConfig: {
            ...validationConfig,
            amount: {
                ...amount,
                range: amountRange
            }
        }
    };
};

/**
 * Reformat config for Validation util
 */
export const reformatValidationConfig = (method) => {
    const { validationConfig } = method;
    const keys = Object.keys(validationConfig);

    return {
        ...method,
        validationConfig: keys.reduce((config, name) => {
            const rules = validationConfig[name];
            const ruleTypes = Object.keys(rules);

            return {
                ...config,
                [name]: ruleTypes
                    .filter(type => Boolean(rules[type]))
                    .map((type) => {
                        const options = rules[type];
                        const creator = ruleCreators[type]; // eslint-disable-line

                        return creator(options);
                    })
            };
        }, {})
    };
};

export default pipe(
    handleAmountRequired,
    mergeAccountFieldsValidation,
    handleAmountRange,
    reformatValidationConfig
);
